export default __webpack_public_path__ + "media/img/logo-8a4a5b892c145376c40db3deb2a68f52.svg";